import React from 'react'
import './anchor.css'
// eslint-disable-next-line react/prop-types
export const Anchor = ({ id }) => {
  return (
        <h6 id={id} className="anchor">
        </h6>
  )
}
